import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Analytics from 'analytics-opencare';

import { useAnalyticsService } from 'services/AnalyticsService';

import { STEP_KEY, generateStepAnalytics } from '../../utils';
import {
  StepWrapper,
  ButtonBlock,
  SecondaryButton,
} from '../../styled-components';
import {
  Title,
  Subtitle,
  OptionBlock,
} from '../../../common/styled-components';
import SingleSelect from '../../../common/components/SingleSelect/SingleSelect';
import { useFunnelStorage } from '../../storage/Storage';

import { options } from './constants';

const analytics = new Analytics();

const HowSoon = ({ position, moveToNextStep }) => {
  const storage = useFunnelStorage();

  const analyticsService = useAnalyticsService();

  const savedHowSoon = storage.get(STEP_KEY.HOW_SOON);

  useEffect(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_how-soon',
      ...generateStepAnalytics(position, storage),
      ...analyticsService.analyticsData,
    });
  }, []);

  const handleClick = (value, index) => {
    analytics.trackClick({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_how-soon',
      name: 'wizard',
      section: 'how-soon',
      position: [index],
      ...generateStepAnalytics(position, storage, {
        response: value,
      }),
    });

    storage.save(STEP_KEY.HOW_SOON, value, true);
    moveToNextStep();
  };

  return (
    <div>
      <Title id="title">How soon would you like to visit the dentist?</Title>
      <Subtitle>
        We'll try to connect you with a dentist who has appointments in your
        time range.
      </Subtitle>
      <StepWrapper>
        <form>
          <OptionBlock row={4}>
            {options.map((option, i) => (
              <SingleSelect
                key={option.id}
                id={option.id}
                title={option.title}
                describedBy="title"
                onChange={() => handleClick(option.data, i + 1)}
                selected={savedHowSoon === option.data}
              />
            ))}
          </OptionBlock>
          <ButtonBlock>
            <SecondaryButton
              data-testid="skip"
              type="submit"
              onClick={() => handleClick('No preference', options.length + 1)}
              selected={savedHowSoon === 'No preference'}
            >
              No preference
            </SecondaryButton>
          </ButtonBlock>
        </form>
      </StepWrapper>
    </div>
  );
};

HowSoon.defaultProps = {
  position: '',
};

HowSoon.propTypes = {
  position: PropTypes.string,
  moveToNextStep: PropTypes.func.isRequired,
};

export default HowSoon;
